import React, { useState, useEffect, useRef, lazy, Suspense } from "react";
import './checkride.css';
import {
    Grid,
    Button
} from "@material-ui/core";
import { Button as AntDButton } from 'antd'

import Services from '../../../Services';
import moment from "moment";
import { message, Modal } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import { CaretLeftOutlined } from "@ant-design/icons";
import { Colors } from "../../../helpers/Colors";

const PageHeader = lazy(() => import("../../../Components/PageHeader"));
const GoBack = lazy(() => import("../../../Components/GoBackButton/GoBack"));
const PageLayout = lazy(() => import("../../../Components/LayoutComponents/PageLayout"));
const AuditTable = lazy(() => import("./EnterAuditTable"));

const {
    employee,
    Storage
} = Services;

const EnterAudit = () => {
    const storage = new Storage();
    const location = useLocation()
    const [modal, setModal] = useState(false)
    const [showSubmitButton, setShowSubmitButton] = useState(false)
    const history = useHistory()
    const [tableData, setTableData] = useState(location?.state?.tableData || []);
    const [crideTextFields, setCrideTextFields] = useState(location?.state?.crideTextFields || {
        assisting: [],
        locomotiveConsist: '',
        TCLoads: '',
        TCEmpties: '',
        TCTotalTonage: '',
        TMTraveled: '',
        Comments: '',
        type: ''
    })
    const [crideAutoComplete, setAutoComplete] = useState(location?.state?.crideAutoComplete || {
        EngineerId: '',
    })
    const [crideDates, setCrideDates] = useState(location?.state?.crideDates || {
        date: '',
        time: '',
        endDate: '',
        endTime: '',
    })
    console.log({ crideDates })

    const [lists, setLists] = useState({
        currentUser: '',
        users: [],
        positions: [],
        departments: [],
        sites: [],
        crews: [],
        assistants: []

    })

    const submitBtn = async (event) => {
        message.destroy();
        event.preventDefault();
        let errorFlag = false;
        let commentFlag = false;
        let data = [];
        let hasError = false;

        tableData?.forEach((table) => {
            Object.keys(table).forEach((key) => {
                const row = table[key];
                if (key !== 'TestingAudit_ItemLists' && key !== 'id' && key !== 'name') {
                    if (!row?.Result) { errorFlag = true }
                    if (row?.Result === "Non-Compliant" && (!row?.Comments || row?.Comments?.trim() === "")) {
                        commentFlag = true;
                    }
                }
                if (key !== 'TestingAudit_ItemLists' && key !== 'id' && key !== 'name') {
                    data.push({ ...row });
                }
            });
        });
        message?.destroy()
        if (commentFlag) return message?.error('Kindly fill all the non-compliant comments!');
        if (errorFlag) return message?.error('Please Select all the result!');
      
        if (hasError) {
            return;
        }
        const fieldProcessors = {
            'ForemanSupId': crideDates?.ForemanSupId?.value || null,
            'Location_Id': crideTextFields.Location_Id?.value || null,
            'TemplateUsed': crideTextFields.TemplateUsed?.value || null,
            'date': moment(crideTextFields?.date)?.format('YYYY-MM-DD'),
            'SubDepartmentID': crideTextFields.SubDepartmentID?.value || null
        };
        const payload = {
            'ForemanSupId': fieldProcessors['ForemanSupId'],
            'Location_Id': fieldProcessors['Location_Id'],
            'TemplateUsed': fieldProcessors['TemplateUsed'],
            'AuditDate': fieldProcessors['date'],
            'SubDepartmentID': fieldProcessors['SubDepartmentID'],
            'Customer': crideTextFields.Customer || null,
            'AuditTime': crideTextFields.AuditTime || null,
            'WorkDescription': crideTextFields.WorkDescription || null,
            'EventComments': crideTextFields.EventComments || null,
            "Question": data
        };
        const response = await employee.sendAuditData(payload);
        if (response?.httpStatus === 200) {

            message.success('Form submitted successfully!');

            history.push('/safety-testing');
        } else {
            message.error(response.message);
        }
    };


    const setListData = async () => {
        let userList = await employee.checkride_table();
        if (userList?.httpStatus == 200) {
            userList = userList?.data;
            userList.map(row => {
                row.name = `${row.firstName} ${row.lastName}`
            })
        }

        let assistingCrewList = await employee.get_crew_user_listing();

        if (assistingCrewList?.httpStatus == 200) {
            assistingCrewList = assistingCrewList?.data?.rows;
            assistingCrewList.map(row => {
                row.name = `${row?.firstName} ${row?.lastName}`
            })
        }

        let templateList = await employee.get_Template()
        if (templateList?.httpStatus == 200) {
            templateList = templateList?.data;
        }
        let siteList = await employee.get_site_listing()
        if (siteList?.httpStatus == 200) {
            siteList = siteList?.data;
        }

        let departmentList = await employee.get_subDepartment_listing();
        if (departmentList.httpStatus == 200) {
            departmentList = departmentList.data || [];
        }

        let currentUser = JSON.parse(storage.get('user_profile'))

        setLists((prev) => {
            return {
                ...prev, users: userList, currentUser: currentUser, location: siteList, templateList: templateList, departments: departmentList
            }
        })
        return true
    }

    const getForemanData = async () => {
        const result = await employee.getForemanData()
        let mappedData = result?.data?.rows?.map((item, index) => {
            return {
                id: item?.id,
                name: item?.firstName + " " + item?.lastName
            }
        })
        setLists((prev) => { return { ...prev, assistants: mappedData } })
    }




    useEffect(() => {
        setListData();
        getForemanData()
    }, []);


    return (
        <Suspense fallback={<div>Loading...</div>}>
            <PageLayout>
                <Grid className="PagesFrame">
                    <PageHeader />

                    <Grid id="PageTitle">Safety Audit Terminal</Grid>
                    <AntDButton onClick={() => setModal(true)} style={{ background: 'white', color: Colors.mainBlue, borderRadius: '10px', fontWeight: "800", marginTop: '10px' }}> <CaretLeftOutlined />Back</AntDButton>

                    <form onSubmit={submitBtn} >
                        <div style={{ display: "grid", gridTemplateColumns: "100%", gap: "20px", marginTop: "50px" }}>
                            <AuditTable tableData={tableData} setTableData={setTableData} setShowSubmitButton={setShowSubmitButton} />
                        </div>
                        {
                            showSubmitButton &&
                            <div style={{ display: "flex", justifyContent: "end" }}>
                                <Button
                                    type="submit"
                                    className="LinkButton"
                                >
                                    Submit
                                </Button>
                            </div>
                        }
                    </form>

                </Grid>

                <Modal centered={true} title="TGS Confirmation" open={modal} footer={null} onCancel={() => { setModal(false) }}>
                    <p style={{ textAlign: "center", fontSize: "14px", }}>TGS is taking you back to the audit event form.  All audit item data will be lost.  Do you want to continue?</p>
                    <div style={{ display: 'flex', justifyContent: "center", gap: "10px" }}>
                        <Button style={{ marginTop: "20px", background: "white", color: "#2863ad" }} onClick={() => setModal(false)}>No</Button>
                        <Button style={{ marginTop: "20px", background: "#2863ad", color: "white" }} onClick={() => history.push({
                            pathname: '/enter-audit', state: {
                                crideTextFields: crideTextFields,
                                crideAutoComplete: crideAutoComplete,
                                crideDates: crideDates,
                                // tableData: location?.state?.tableData
                            }
                        })} > Yes</Button>
                    </div>
                </Modal>
            </PageLayout>
        </Suspense >
    );
}

export default EnterAudit;
